import { KYMW1102SearchResultModel } from '../vo/kymw1102-search-result.model';
import { KYMW1102Model } from '../kymw1102.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 新規取扱情報帳票出力日更新
 *
 * @export UpdateReportOutputDateService
 * @class UpdateReportOutputDateService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class UpdateReportOutputDateService extends PlessJsonResponderSub<any> {

  // VO
  private vo: KYMW1102SearchResultModel = new KYMW1102SearchResultModel;
  // 処理に使用するModel
  private model: KYMW1102Model;
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof UpdateReportOutputDateService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      update: {
        UpdateList: {
          combination: this.vo.PCodes.map((pCode, i) => ({
            condition: {
              PCodes: pCode,
              ItemCodes: this.vo.ItemCodes[i],
            }
          }))
        }
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model 処理に使用するモデル
   * @param vo vo
   * @param successFunc 成功時に実行される処理
   * @memberof UpdateReportOutputDateService
   */
  execute(model: KYMW1102Model, vo: KYMW1102SearchResultModel, successFunc: Function = null): void {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;

    this.send('updateReportOutputDate', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof UpdateReportOutputDateService
   */
  success(data: any): void {
    if (this.successFunc !== null) {
      this.successFunc(data);
    }
  }
}
